module.exports = __webpack_public_path__ + "static/media/app_lookout.72a47cab.png";